import React, { useEffect, useMemo, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import logo from "./logo.png";

function Topbar({ onMenuClick }) {
  const history = useHistory();
  const { user, logout } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  const fullName = [user?.firstname, user?.lastname].filter(Boolean).join(" ") || user?.username || "User";
  const userRole = user?.role || "Authenticated user";
  const initials = useMemo(() => {
    const parts = fullName.split(" ").filter(Boolean);
    return parts.slice(0, 2).map((part) => part[0]?.toUpperCase()).join("") || "U";
  }, [fullName]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  function handleLogout() {
    setMenuOpen(false);
    logout();
    history.push("/login");
  }

  return (
    <header className="topbar">
      <button type="button" className="btn btn-light topbar-menu d-lg-none" onClick={onMenuClick}>
        <i className="bi bi-list" />
      </button>

      <div className="topbar-brand">
        <div className="topbar-emblem" aria-hidden="true">
          <img src={logo} alt="" className="topbar-emblem-image" />
        </div>

        <div className="topbar-government-copy">
          <p className="topbar-government-line">Republic of Uganda</p>
          <h1 className="topbar-government-title">Ministry of Health</h1>
        </div>

        <div className="topbar-divider" aria-hidden="true" />

        <div className="topbar-product-copy">
          <h2 className="topbar-product-title">UNEPI Integrated Workplan and Tasks Tracker</h2>
        </div>
      </div>

      <div className="topbar-user-menu" ref={menuRef}>
        <button
          type="button"
          className="topbar-user-trigger"
          onClick={() => setMenuOpen((value) => !value)}
          aria-expanded={menuOpen}
        >
          <div className="topbar-avatar" aria-hidden="true">
            {initials}
          </div>

          <div className="topbar-user-copy d-none d-sm-block">
            <div className="topbar-user-name">{fullName}</div>
            <small className="topbar-user-role">{userRole}</small>
          </div>

          <i className={`bi ${menuOpen ? "bi-chevron-up" : "bi-chevron-down"}`} />
        </button>

        <div className={`topbar-dropdown ${menuOpen ? "show" : ""}`}>
          <button type="button" className="topbar-dropdown-action" onClick={handleLogout}>
            <i className="bi bi-box-arrow-right" />
            <span>Logout</span>
          </button>
        </div>
      </div>
    </header>
  );
}

export default Topbar;
